export default __webpack_public_path__ + "static/media/Crown.8881eb95.svg";